export const LOCAL_STORAGE_KEY_SHOPPING_CART_LIST = 'shop-cartState';
